import { dec, toDecimalString } from './decimal.js';
/** factor = requestedServings / originalServings, as a canonical decimal string. */
export function scalingFactor(originalServings, requestedServings) {
    const orig = dec(originalServings);
    if (orig.lte(0))
        throw new RangeError('originalServings must be positive');
    const req = dec(requestedServings);
    if (req.lte(0))
        throw new RangeError('requestedServings must be positive');
    return toDecimalString(req.div(orig));
}
/**
 * scaled = original × requested / original servings, computed with decimal arithmetic.
 * Non-scalable rows and text-only quantities are returned unchanged.
 * A factor of exactly 1 returns the original strings verbatim.
 */
export function scaleQuantity(row, factor) {
    const f = dec(factor);
    if (!row.scalable || row.quantity === null || f.equals(1)) {
        return { quantity: row.quantity, quantityMax: row.quantityMax, scaled: false };
    }
    const quantity = toDecimalString(dec(row.quantity).times(f));
    const quantityMax = row.quantityMax === null ? null : toDecimalString(dec(row.quantityMax).times(f));
    return { quantity, quantityMax, scaled: true };
}
export function scaleByServings(row, originalServings, requestedServings) {
    return scaleQuantity(row, scalingFactor(originalServings, requestedServings));
}
//# sourceMappingURL=scaling.js.map